import type { ReactNode } from 'react'
import { ClockIcon, InfoIcon, CheckIcon } from './icons'
import styles from './Strip.module.css'

export type StripTone = 'ok' | 'info' | 'warn' | 'bad'

interface Props {
  tone: StripTone
  children: ReactNode
  /** Правая подпись: «Время на оплату» и подобное. */
  aside?: ReactNode
  /** Иконка слева. По умолчанию подбирается по тону. */
  icon?: ReactNode
  /** Сообщение меняется само (пришёл платёж) — озвучить читалке. */
  live?: boolean
}

/**
 * Цветная полоса состояния: таймер, «ждём перевод», ошибка, подсказка.
 *
 * Один компонент на все четыре тона, потому что в макете это один
 * компонент. Разные — значит рано или поздно разъедутся отступами.
 */
export function Strip({ tone, children, aside, icon, live }: Props) {
  return (
    <div
      className={`${styles.strip} ${styles[tone]}`}
      role="status"
      aria-live={live ? 'polite' : undefined}
    >
      <span className={styles.mark}>{icon ?? defaultIcon(tone)}</span>
      <span className={styles.main}>{children}</span>
      {aside ? <span className={styles.aside}>{aside}</span> : null}
    </div>
  )
}

function defaultIcon(tone: StripTone): ReactNode {
  if (tone === 'ok') return <CheckIcon size={24} />
  return tone === 'warn' || tone === 'bad' ? <ClockIcon /> : <InfoIcon />
}
